import styled from 'styled-components'

export const StatsWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`

export const StatItem = styled.div`
    width: 200px;
`

export const Title = styled.div`
    font-size: 0.9rem;
    color: #202223;
`

export const Content = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    margin-top: 10px;
`

export const CircularSign = styled.span`
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: ${props => props.color};
`
